import { render, staticRenderFns } from "./RemCancel.vue?vue&type=template&id=61acb544&scoped=true&"
import script from "./RemCancel.vue?vue&type=script&lang=js&"
export * from "./RemCancel.vue?vue&type=script&lang=js&"
import style0 from "./RemCancel.vue?vue&type=style&index=0&id=61acb544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61acb544",
  null
  
)

export default component.exports